import { createAsyncThunk } from "@reduxjs/toolkit";
import { type FailedDeliveryDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Loads the delivery-attempt cap from Constantes (DMS-35), so the screen says
 *  which attempt this is against the cap the backend actually enforces. */
export const loadMaxAttempts = createAsyncThunk<
  number,
  void,
  { dispatch: FailedDeliveryDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOAD_MAX_ATTEMPTS, async (_, { extra }) => {
  return extra.failedDeliveryRepo.getMaxAttempts();
});
